import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'


const RECOMMENDATION_TEXT_VALID = 'Рекомендуется к трудоустройству';
const RECOMMENDATION_TEXT_INVALID = 'Не рекомендуется к трудоустройству';


Vue.use(Vuex);

function calc_value(score, len) {
    if (len === 5) {
        if (score > 0 && score < 11.9) {
            return 1
        } else if (score >= 11.9 && score < 13.8) {
            return 1.5
        } else if (score >= 13.8 && score < 15.6) {
            return 2
        } else if (score >= 15.6 && score < 17.5) {
            return 2.5
        } else if (score >= 17.5 && score < 19.4) {
            return 3
        } else if (score >= 19.4 && score < 21.3) {
            return 3.5
        } else if (score >= 21.3 && score < 23.1) {
            return 4
        } else if (score >= 23.1 && score < 25) {
            return 4.5
        } else if (score >= 25) {
            return 5
        }
    } else if (len === 6) {
        if (score > 0 && score < 14.3) {
            return 1
        } else if (score >= 14.3 && score < 16.5) {
            return 1.5
        } else if (score >= 16.5 && score < 18.8) {
            return 2
        } else if (score >= 18.8 && score < 21.0) {
            return 2.5
        } else if (score >= 21.0 && score < 23.3) {
            return 3
        } else if (score >= 23.3 && score < 25.5) {
            return 3.5
        } else if (score >= 25.5 && score < 27.8) {
            return 4
        } else if (score >= 27.8 && score < 30) {
            return 4.5
        } else if (score >= 30) {
            return 5
        }

    } else if (len === 7) {
        if (score > 0 && score < 16.6) {
            return 1
        } else if (score >= 16.6 && score < 19.3) {
            return 1.5
        } else if (score >= 19.3 && score < 21.9) {
            return 2
        } else if (score >= 21.9 && score < 24.5) {
            return 2.5
        } else if (score >= 24.5 && score < 27.1) {
            return 3
        } else if (score >= 27.1 && score < 29.8) {
            return 3.5
        } else if (score >= 29.8 && score < 32.4) {
            return 4
        } else if (score >= 32.4 && score < 35) {
            return 4.5
        } else if (score >= 35) {
            return 5
        }
    }
    return 0.0
}

export default new Vuex.Store({
    state: {
        templateNumber: 1,
        q_one: {}
    },
    getters: {
        TEMPLATE_NUMBER: state => {
            return state.templateNumber
        },
        Q_ONE: state => {
            return state.q_one
        },
        POOLS: state => {
            return state.q_one.pools
        },
        ALL_LEVEL_FILL: state => {
            let result = true;
            if (state.q_one.pools) {
                state.q_one.pools.forEach(function (item) {
                    if (item.result === null) {
                        result = false;
                    } else if (item.result == 0) {
                        result = false;
                    }
                });
            } else {
                result = false;
            }
            return result;
        },
        ALL_COMPETENTIONS_FILL: state => {
            let result = true;
            if (state.q_one.pools) {
                state.q_one.pools.forEach(function (item) {
                    item.assessments.body.forEach(function (item) {
                        if (item.value === null) {
                            result = false;
                        }
                    });
                });
            }
            return result;
        }
    },
    mutations: {
        SET_ASSESSMENT: (state, payload) => {
            let BreakException = {};
            state.q_one.pools[payload.poolindex].assessments.body[payload.assessmentindex].value = payload.value;
            let recommendation = '';
            state.q_one.pools.forEach(function (item) {
                const len = item.assessments.body.length;
                let score = 0;
                let num_nd = 0;
                try {
                    item.assessments.body.forEach(function (item) {
                        if (item.value === 1) {
                            num_nd++;
                            if (num_nd >= 2) {
                                throw BreakException;
                            }
                            score = score + item.value;
                        } else {
                            score = score + item.value;
                        }
                    });
                    // let val = score / len;
                    // let val = calc_value(score, len);
                    // item.result = (Math.round(val * 2) / 2).toFixed(1);
                    item.result = calc_value(score, len);
                    if (item.result < state.q_one.min_level) {
                        recommendation = RECOMMENDATION_TEXT_INVALID;
                    }
                } catch (e) {
                    if (e !== BreakException) {
                        throw e;
                    } else {
                        item.result = '2НД';
                        recommendation = RECOMMENDATION_TEXT_INVALID;
                    }
                }
            });
            if (recommendation === RECOMMENDATION_TEXT_INVALID) {
                state.q_one.recommendation = recommendation;
            } else {
                state.q_one.recommendation = RECOMMENDATION_TEXT_VALID;
            }
        },
        SET_STATUS: (state, payload) => {
            state.q_one.status = payload;
        },
        SET_COMMENTS: (state, payload) => {
            state.q_one.pools[payload.poolindex].assessments.comments = payload.comments;
        },
        SET_RECEIVED: (state, payload) => {
            state.q_one = payload.object;
        }
    },
    actions: {
        SAVE_STATUS: async (context, payload) => {
            context.commit('SET_STATUS', payload);
            context.dispatch('SEND_DATA', context.getters.Q_ONE);
        },
        SAVE_ASSESSMENT: async (context, payload) => {
            context.commit('SET_ASSESSMENT', payload);
            context.dispatch('SEND_DATA', context.getters.Q_ONE);
        },
        SAVE_COMMENTS: async (context, payload) => {
            context.commit('SET_COMMENTS', payload);
            context.dispatch('SEND_DATA', context.getters.Q_ONE);
        },
        SAVE_TEMPLATE: async (context, payload) => {
            try {
                let data = await Axios.get('api/add', {
                    params: {
                        'type': payload.type,
                        'name': payload.name,
                        'family': payload.family,
                        'patron': payload.patron
                    }
                });
                context.commit('SET_TEMPLATE', data.data.object);
            } catch (e) {
                console.log('SAVE_TEMPLATE_ERROR <- ', e.message)
            }
        },
        SEND_DATA: async (context, payload) => {
            let data_send = {object: payload};
            let {data} = await Axios.post('/api', data_send);
            if (data_send.object.status === 1) {
                window.location.replace(data_send.object.return_url)
            }
        },
        RECEIVED_DATA: async (context, payload) => {
            if (payload) {
                console.log('RECEIVED_DATA -> ', payload);
                try {
                    let {data} = await Axios.get('/api/' + payload);
                    console.log('RECEIVED_DATA <- ', data);
                    context.commit('SET_RECEIVED', data)
                } catch (e) {
                    console.log('RECEIVED_DATA <- ', e.message)
                }

            }
        },
        CREATE_ASSESSMENT: async (context, payload) => {
            console.log('payload: ', payload);
            try {
                let data = await Axios.get('api/add', {
                    params: {
                        'type': payload.type,
                        'name': payload.name,
                        'family': payload.family,
                        'patron': payload.patron,
                        'email': payload.email
                    }
                });
                console.log('CREATE_ASSESSMENT: ', data.data);
                return data.data;

            } catch (e) {
                console.log('SAVE_TEMPLATE_ERROR <- ', e.message)
            }
        }
    }
})
